import { render } from "./AddClientForm.vue?vue&type=template&id=6a42910e&scoped=true"
import script from "./AddClientForm.vue?vue&type=script&lang=js"
export * from "./AddClientForm.vue?vue&type=script&lang=js"

import "./AddClientForm.vue?vue&type=style&index=0&id=6a42910e&scoped=true&lang=css"

import exportComponent from "/Users/chrisrooster/Documents/Sites/mycelium/server/src/views/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a42910e"]])

export default __exports__